import React, { SyntheticEvent, useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BusinessListPanel from '../components/BusinessListPanel';
import DefaultBusinessSettingPanel from '../components/businessSettings/DefaultBusinessSettingPanel';

type BusinessStatus = 'active' | 'deactivated';

// 'default' is the global default business settings tab; the rest filter the business list by status.
type TabValue = BusinessStatus | 'default';

const TAB_VALUES: Array<TabValue> = ['active', 'deactivated', 'default'];

export default function MainPage() {
  const title = 'Businesses';
  const [activeTab, setActiveTab] = useState<TabValue>('active');

  function handleTabChange(_event: SyntheticEvent, newValue: number) {
    setActiveTab(TAB_VALUES[newValue]);
  }

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageHeader title={title} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={TAB_VALUES.indexOf(activeTab)} onChange={handleTabChange}>
          <Tab label="Active" />
          <Tab label="Deactivated" />
          <Tab label="Default Business Setting" />
        </Tabs>
      </Box>
      <Box mt={2}>
        {activeTab === 'default' ? (
          <DefaultBusinessSettingPanel />
        ) : (
          <BusinessListPanel key={activeTab} status={activeTab} />
        )}
      </Box>
    </Container>
  );
}
